var App = App || {};

App.WellnessVillage = (function() {
  'use strict';

  var initialize = function() {
    _createFeatureCardSlides();
  };

  var _createFeatureCardSlides = function() {
    $('.wv-featured-slides').slick({
      arrows: true,
      prevArrow: $('.wv-featured-prev'),
      nextArrow: $('.wv-featured-next'),
      mobileFirst: true,
      slidesToShow: 1,
      responsive: [
        {
          breakpoint: 640,
          settings: {
            centerMode: true
          }
        }
      ]
    });
  };

  return {
    initialize: initialize
  };
}());



App.WellnessVillageSubnav = (function() {
  'use strict';

  var initialize = function() {
    _bindSubnavSelects();
  };

  var _bindSubnavSelects = function() {
    $('.js-navigate-on-select').on('change', function() {
      window.location.href = $(this).val();
    });
  };

  return {
    initialize: initialize
  };
}());